/**
 * The doc editor reports its title and body as one HTML document, the title
 * as the first block. Splits a change into the parts that actually changed:
 * a body edit flips a published doc to Unpublished changes, so a title-only
 * edit must not resend an unchanged body. `bodies` holds the body as saved
 * and as handed to the editor; matching either means the body is unchanged.
 */
export const docEditorChanges = ({
  html,
  title,
  bodies,
}: {
  html: string;
  title: string;
  bodies: string[];
}): { title?: string; body?: string } => {
  const container = document.createElement("div");
  container.innerHTML = html;
  const titleElement = container.firstElementChild;
  let newTitle = title;
  if (titleElement) {
    newTitle = titleElement.textContent || "";
    titleElement.remove();
  }
  const newBody = container.innerHTML;
  return {
    ...(newTitle !== title ? { title: newTitle } : {}),
    ...(bodies.includes(newBody) ? {} : { body: newBody }),
  };
};
